import { FolderOutlineSVG } from '../../@common_components/svgs/folder-outline.svg';
import { FolderOpenSVG } from '../../@common_components/svgs/folder-open.svg';

interface FolderIconProps {
  isEmpty: boolean;
  className?: string;
}

/** Dossier vide = contour, dossier plein = solide ouvert */
export function FolderIcon( { isEmpty, className }: FolderIconProps ) {
  const classes = `${ className ?? '' }`.trim();
  const style = { color: '#ef4444' } as React.CSSProperties;
  if ( isEmpty ) {
    return <FolderOutlineSVG className={ classes } style={ style } />;
  }

  return <FolderOpenSVG className={ classes } style={ style } />;
}
